import axios from "axios";
import React, { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import OurSuccess from "../component/OurSuccess";
import Partner from "../component/Partner";
import BreadCumb from "../component/BreadCumb";
import WhyHire from "../component/WhyHire";
import GlobalReach from "../component/GlobalReach";
import SectionPage from "../component/SectionPage";
import Training from "../component/Training";
import FlightDeployment from "../component/FlightDeployment";
import RecruitmentProcess from "../component/RecruitmentProcess";

const About = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [aboutUs, setAboutUs] = useState([]);
    const cacheExpiryTime = 30 * 60 * 1000; // Cache expiry time (30 minutes)

    useEffect(() => {
        // Check if cached data exists
        const cachedData = JSON.parse(localStorage.getItem('aboutUsData'));

        if (cachedData) {
            const { data, timestamp } = cachedData;
            const currentTime = Date.now();

            if (currentTime - timestamp < cacheExpiryTime) {
                // If the cache is still valid, use the cached data
                setAboutUs(data);
            } else {
                // If the cache has expired, fetch new data
                localStorage.removeItem('aboutUsData');
                fetchAboutUsData();
            }
        } else {
            // If no cached data, fetch new data
            fetchAboutUsData();
        }
    }, []);

    const fetchAboutUsData = async () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_ABOUT_US;

        try {
            const response = await axios.get(`${apiBaseUrl}${Url}`);
            const fetchedData = response.data;

            // Cache the fetched data with the current timestamp
            const dataWithTimestamp = {
                data: fetchedData,
                timestamp: Date.now(),
            };
            localStorage.setItem('aboutUsData', JSON.stringify(dataWithTimestamp));
            setAboutUs(fetchedData);
        } catch (error) {
            console.error('Failed to fetch About Us:', error);
        }
    };

    return (
        <main className="main">
            <BreadCumb image="aboutus.webp" />
            {/* About Tarif Overseas Ltd. Section */}
            <section className="pt-20 pb-20">
                <div className="container px-0">
                    <img src="/aboutussection.jpg" alt="Tarif Overseas Headquarters" className="img-fluid" style={{ borderRadius:"15px" }} />
                </div>
            </section>
            {/* End About Section */}

            {/* Why Hire From Bangladesh? Section */}
            <WhyHire />
            {/* End Why Hire Section */}

            <GlobalReach />
            <SectionPage />
            <Training />
            <FlightDeployment />
            <RecruitmentProcess />
            <OurSuccess />
            <Partner />
        </main>
    );
}

export default About;
